import { render } from "./KeteranganView.vue?vue&type=template&id=241e6e14"
import script from "./KeteranganView.vue?vue&type=script&lang=js"
export * from "./KeteranganView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__